import React, { useContext, useState } from "react";
import { Modal, Form, InputNumber, Input, message } from "antd";
import { useTranslation } from "react-i18next";
import DeliveryWorkerContext from "../../../context/delivery-worker/context";

const { TextArea } = Input;

interface IReceiveInsuranceModalProps {
  visible: boolean;
  onClose: () => void;
  workerId: number;
}

const ReceiveInsuranceModal: React.FC<IReceiveInsuranceModalProps> = ({
  visible,
  onClose,
  workerId,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { actions, loading } = useContext(DeliveryWorkerContext);
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);

      const success = await actions.receiveInsurance(workerId, {
        insuranceAmount: values.insuranceAmount,
        insuranceReceivedNote: values.insuranceReceivedNote || undefined,
      });

      if (success) {
        message.success(t("insurance_received_successfully"));
        form.resetFields();
        onClose();
      }
    } catch (error) {
      console.error("Failed to receive insurance:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={t("receive_insurance")}
      open={visible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      confirmLoading={submitting || loading.includes("receiveInsurance")}
      okText={t("confirm")}
      cancelText={t("cancel")}
      width={450}
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="insuranceAmount"
          label={t("insurance_amount")}
          rules={[
            { required: true, message: t("required") },
            { type: "number", min: 0.01, message: t("min_value_error") },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            placeholder={t("insurance_amount")}
            min={0.01}
            precision={2}
          />
        </Form.Item>

        <Form.Item
          name="insuranceReceivedNote"
          label={t("insurance_received_note")}
        >
          <TextArea
            rows={3}
            placeholder={t("insurance_received_note")}
            maxLength={1000}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReceiveInsuranceModal;
